import { createRouter, createWebHistory } from 'vue-router';

import JaLogin from '@/components/JaLogin.vue';
import JaMonitorManagement from '@/components/JaMonitorManagement/JaMonitorManagement.vue';
import JaContentSelect from '@/components/JaStreamGroup/JaContentSelect.vue';
import JaStreamGroupName from '@/components/JaStreamGroup/JaStreamGroupName.vue';
import JaStreamGroupConfirm from '@/components/JaStreamGroup/JaStreamGroupConfirm.vue';
import JaStreamGroupWrapper from '@/components/JaStreamGroup/JaStreamGroupWrapper.vue';
import JaMaterialDelete from '@/components/JaContent/JaMaterialDelete.vue';
import JaHome from '@/components/JaHome.vue';
import JaManualLinks from '@/components/JaManualLinks.vue';
import JaContentWrapper from '@/components/JaContent/JaContentWrapper.vue';
import JaTemplateSelect from '@/components/JaContent/JaTemplateSelect.vue';
import JaMaterialSelect from '@/components/JaContent/JaMaterialSelect.vue';
import JaContentConfirm from '@/components/JaContent/JaContentConfirm.vue';
import JaContentDetail from '@/components/JaContent/JaContentDetail.vue';
import JaContentImageResize from '@/components/JaContent/JaContentImageResize.vue';
import JaContentFrameSelect from '@/components/JaContent/JaContentFrameSelect.vue';
import JaStreamGroupDetail from '@/components/JaStreamGroup/JaStreamGroupDetail.vue';

const routes = [
  { path: '/', redirect: { name: 'ja-login' } },
  {
    path: '/ja/home',
    name: 'ja-home',
    component: JaHome,
  },
  {
    path: '/ja/login',
    name: 'ja-login',
    component: JaLogin,
  },
  {
    path: '/ja/monitorManagement',
    name: 'ja-monitor-management',
    component: JaMonitorManagement,
  },
  {
    path: '/ja/content',
    name: 'ja-content-wrapper',
    component: JaContentWrapper,
  },
  {
    path: '/ja/content/templateSelect',
    name: 'ja-template-select',
    component: JaTemplateSelect,
  },
  {
    path: '/ja/content/materialSelect',
    name: 'ja-material-select',
    component: JaMaterialSelect,
  },
  {
    path: '/ja/content/materialDelete',
    name: 'ja-material-delete',
    component: JaMaterialDelete,
  },
  {
    path: '/ja/content/contentConfirm',
    name: 'ja-content-confirm',
    component: JaContentConfirm,
  },
  {
    path: '/ja/content/frameSelect',
    name: 'ja-frame-select',
    component: JaContentFrameSelect,
  },
  {
    path: '/ja/content/contentDetail/:contentId',
    name: 'ja-content-detail',
    component: JaContentDetail,
  },
  {
    path: '/ja/content/contentImageResize/:materialNum',
    name: 'ja-content-image-resize',
    component: JaContentImageResize,
  },
  {
    path: '/ja/streamGroup',
    name: 'ja-stream-group-wrapper',
    component: JaStreamGroupWrapper,
  },
  {
    path: '/ja/streamGroup/contentSelect',
    name: 'ja-content-select',
    component: JaContentSelect,
  },
  {
    path: '/ja/streamGroup/streamGroupName',
    name: 'ja-stream-group-name',
    component: JaStreamGroupName,
  },
  {
    path: '/ja/streamGroup/streamGroupConfirm',
    name: 'ja-stream-group-confirm',
    component: JaStreamGroupConfirm,
  },
  {
    path: '/ja/streamGroup/streamGroupDetail',
    name: 'ja-stream-group-detail',
    component: JaStreamGroupDetail,
  },
  {
    path: '/ja/manualLinks',
    name: 'ja-manual-links',
    component: JaManualLinks,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

// 画面遷移が行われる前に呼ばれるメソッド
router.beforeEach((to, from, next) => {
  // JWTが存在しない場合(未ログイン状態)
  if (localStorage.getItem('token') === null) {
    // ①遷移先がログイン画面ならそのままログイン画面へ遷移
    if (to.path === '/ja/login') {
      next();
    }
    // ②遷移先がログイン画面以外なら強制的に遷移先をログイン画面に変更(その後①のケースを実行し画面遷移終了)
    else {
      next('/ja/login');
    }
  }
  // ③JWTが存在し、かつ遷移先がログイン画面の場合は強制的に遷移先をホーム画面に変更(その後⑤のケースを実行し画面遷移終了)
  else if (to.path === '/ja/login') {
    next('/ja/home');
  }
  // ④JWTが存在し、かつ遷移元が配信グループの管理画面かホーム画面で、遷移先がコンテンツの詳細画面の場合は、強制的に遷移先をホーム画面に変更
  // (その後⑤のケースを実行し画面遷移終了 ブラウザバック考慮)
  else if (
    (from.path === '/ja/streamGroup' || from.path === '/ja/home') &&
    to.path.includes('/ja/content/contentDetail')
  ) {
    next('/ja/home');
  } else {
    // ⑤JWTが存在し、かつ③と④以外はそのまま画面遷移
    next();
  }
});

export default router;
